import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { CurrenciesAvailableBlock } from './CurrenciesAvailable';
import { CurrenciesEnableBlock } from './CurrenciesEnable';
import { Button, ButtonClose } from '@/components/buttons';
import { Modal } from '@/components/Modal';
import { ModalSelectContainer } from '@/components/ModalSelect';
import { useCommonStore } from '@/store/commonStore';

import { ScEditCurrenciesContent, ScModalEditCurrencies } from './styled';

interface EditCurrenciesProps {
  onClose: () => void;
}

export const EditCurrenciesModal: FC<EditCurrenciesProps> = ({ onClose }) => {
  const { t } = useTranslation('deposits');
  const { images } = useTheme();
  const isMobileDevice = useCommonStore.use.isMobileDevice();

  return isMobileDevice ? (
    <ModalSelectContainer
      title={t('editCurrency.myCurrencies')}
      onClose={onClose}
      icon={<images.currencyIcon.component />}
      innerAlignBottom
      openOptionsInPortal
    >
      <EditCurrenciesContent onClose={onClose} />
    </ModalSelectContainer>
  ) : (
    <Modal isPortal>
      <ScModalEditCurrencies>
        <ButtonClose dark top={16} right={16} onClick={onClose} />
        <div className="top-box">
          <images.currencyIcon.component />
          {t('editCurrency.myCurrencies')}
        </div>
        <EditCurrenciesContent onClose={onClose} />
      </ScModalEditCurrencies>
    </Modal>
  );
};

const EditCurrenciesContent: FC<EditCurrenciesProps> = ({ onClose }) => {
  const { t } = useTranslation('deposits');
  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const backButton = useMemo(
    () => (
      <div className="btn-box">
        <Button
          type="button"
          whiteTransparent={isMobileDevice}
          blackTransparent={!isMobileDevice}
          onClick={onClose}
          large
          wide
        >
          {t('back')}
        </Button>
      </div>
    ),
    [isMobileDevice, onClose, t]
  );

  return (
    <ScEditCurrenciesContent>
      <CurrenciesEnableBlock />
      <CurrenciesAvailableBlock />

      {backButton}
    </ScEditCurrenciesContent>
  );
};
